import { StableChildren } from '@prophecy/utils/react/StableChildren';
import { createContext, useContext } from 'react';

const ProviderTypeOverrideContext = createContext<string | undefined>(undefined);

export const ProviderTypeOverrideProvider = ({
  children,
  providerType
}: {
  children: React.ReactNode;
  providerType?: string;
}) => {
  return (
    <ProviderTypeOverrideContext.Provider value={providerType}>
      <StableChildren>{children}</StableChildren>
    </ProviderTypeOverrideContext.Provider>
  );
};

export const useProviderTypeOverride = () => {
  return useContext(ProviderTypeOverrideContext);
};
